module.exports = __webpack_public_path__ + "static/gm-28-137c6611b4d295f4cceb413a3f504624.jpg";